import * as d3 from 'd3';

const ANIMATION_DURATION = 300;

export const generateLinesAndDots = (scopeChartData, dataPointsParName) => {
  var lines = [];
  var dots = [];

  scopeChartData.forEach(function(chartData) {
    var line = {};
    
    line.name = chartData.firstName;
    line.data = [];
    line.color = chartData.color;
    line.isMain = chartData.isMain;
    line.id = chartData.teamId ? (chartData.teamId + '_teamId') : chartData.playerId;
    
    if(chartData[dataPointsParName] !== null) {
      chartData[dataPointsParName].forEach(function(point, i) {
        if(point !== null) {
          line.data.push({
            y: point,
            x: i
          });
  
          dots.push({
            y: point,
            x: i,
            color: chartData.color,
            label: chartData.label
          });
        }
      });
    }

    lines.push(line);
  }); 

  return {
    lines: lines,
    dots: dots
  }
}

export const appendAndGenerateTooltip = (root, width, height) => {
  var tooltip = root.append("g")
    .attr("class", "chart-tooltip")
    .style("display", "none");

  tooltip.append("rect")
    .attr("width", width)
    .attr("height", height)
    .attr("fill", "#000000")

  tooltip.append("text")
    .attr('class', 'tooltip-header')
    .attr("x", 15)
    .attr("dy", 25)
    .attr("fill", "#fff")
    .attr("font-size", "14px")
    .append('tspan')
    .attr('class', 'tooltip-tspan')

  tooltip.append("text")
    .attr('class', 'tooltip-value-x')
    .attr("x", 15)
    .attr("dy", 45)
    .attr("font-size", "14px")
    .attr("fill", "#fff")

  tooltip.append("text")
    .attr('class', 'tooltip-value-y')
    .attr("x", 15)
    .attr("dy", 65)
    .attr("font-size", "14px")
    .attr("fill", "white")

  return tooltip;
}

export const appendAndGenerateFocus = (root, width, height) => {
  // Focus (line, circle and rect)
  var focus = root.append("g")
    .attr("class", "focus")
    .style("display", "none")

  focus.append("line")
    .attr("class", "x-hover-line hover-line")
    .attr("y1", 0)
    .attr("y2", height);

  focus.append("line")
    .attr("class", "y-hover-line hover-line")
    .attr("x1", width)
    .attr("x2", width);

  focus.append("circle")
    .attr("r", 4.5)

    return focus;
}

export const drawBrushes = (gBrushes, brushes) => {
  var brushSelection = gBrushes.selectAll(".brush").data(brushes, function(d) {
    return d ? d.id : d;
  });

  // Set up new brushes
  brushSelection
    .enter()
    .insert("g", ".brush")
    .attr("class", "brush")
    .attr("id", function(brush) {
      return "brush-creation-" + brush.id;
    })
    .each(function(brushObject) {
      //call the brush
      brushObject.brush(d3.select(this));
    });

  brushSelection.each(function() {
    d3.select(this)
      .attr("class", "brush")
      .selectAll(".overlay")
      .style("pointer-events", function() {
        return "none";
      });
  });

  brushSelection.exit().remove();
}

export const drawSegments = (segments, gSegments, zoomedSelection, xMaxDecimal, width, chartHeight, locationHref) => {
  if(segments) {
    gSegments.selectAll('.segment-group').remove();

    segments.forEach(function(s) {
      if(s.id) {
        const gSegment = gSegments
          .append('g')
          .attr('class', 'segment-group')
          .attr('data-segment-id', s.id)
          .attr('clip-path', 'url(' + locationHref + '#clip)');

        const zoomedMinutesLength = zoomedSelection[1] - zoomedSelection[0];
        const segmentWidthInMinutes = (s.endPoint / 60) - (s.startPoint / 60);
        const startPointMinutes = s.startPoint / 60;
        const minutesWidth = xMaxDecimal;
        const zoomedRatio = minutesWidth / zoomedMinutesLength;
        const segmentWidth = (segmentWidthInMinutes / minutesWidth) * width * zoomedRatio;
        const startMinutesDiff = startPointMinutes - zoomedSelection[0];
        const startPoint = (startMinutesDiff / zoomedMinutesLength) * width;

        if(segmentWidth > 0) {
          gSegment
            .append('rect')
            .attr('id', 'segment-id-' + s.id)
            .transition()
            .duration(ANIMATION_DURATION)
            .ease(d3.easeLinear)
            .attr('width', segmentWidth)
            .attr("height", chartHeight)
            .attr('transform', 'translate(' + (startPoint) + ',' + 0 + ')')
            .attr("fill", "#5E5E62")
            .attr('stroke', '#5E5E62')
            .attr('stroke-width', '1px')
            .attr('shape-rendering', 'crispedges')
            .attr('stroke-dasharray', '3px 3px')
            .attr('fill-opacity', 0.2)

          if(s.name) {
            const segmentText = gSegment
              .append('text')
              .attr('id', 'segment-name-id-' + s.id)
              .attr("font-size", "14px")
              .attr("fill", "#fff")

            segmentText
              .append('tspan')
              .attr('class', 'segment-tspan')
              .text(function() { return s.name }).each(function() { 
                segmentLabelOverflowHandler.call(this, chartHeight);
              })

            segmentText
              .transition()
              .duration(ANIMATION_DURATION)
              .ease(d3.easeLinear)
              .attr('transform', 'translate(' + (startPoint + segmentWidth - 20) + ',' + 10 + ')rotate(90)')
          }
        }
      }
    });
  }
}

export const updateSegments = (segments, main, zoomedSelection, xMaxDecimal, width, chartHeight) => {
  if(segments) {
    segments.forEach(function(s) {
      var zoomedMinutesLength = zoomedSelection[1] - zoomedSelection[0];
      var segmentWidthInMinutes = (s.endPoint / 60) - (s.startPoint / 60);
      var startPointMinutes = s.startPoint / 60;
      var minutesWidth = xMaxDecimal;
      var zoomedRatio = minutesWidth / zoomedMinutesLength;
      var segmentWidth = (segmentWidthInMinutes / minutesWidth) * width * zoomedRatio;
      var startMinutesDiff = startPointMinutes - zoomedSelection[0];
      var startPoint = (startMinutesDiff / zoomedMinutesLength) * width;

      main.selectAll('#segment-id-' + s.id)
        .transition()
        .duration(ANIMATION_DURATION)
        .ease(d3.easeLinear)
        .attr('width', segmentWidth)
        .attr('height', chartHeight)
        .attr('transform', 'translate(' + (startPoint) + ',' + 0 + ')');

      if(s.name) {
        main.selectAll('#segment-name-id-' + s.id)
          .transition()
          .duration(ANIMATION_DURATION)
          .ease(d3.easeLinear)
          .attr('transform', 'translate(' + (startPoint + segmentWidth - 20) + ',' + 10 + ')rotate(90)');
      }
    });
  }
}

export const appendLinesToChart = (lines, main, lineGenerator, zoomPreviewLineGenerator, zoomContext, locationHref) => {
  // Generate lines by chart data
  lines.forEach(function(lineData) {
    appendSingleLine(main, lineData, zoomContext, lineGenerator, zoomPreviewLineGenerator, 'default-path', false, locationHref);
    
    const preciseData = {};
    preciseData.data = [];
    preciseData.color = lineData.color;
    preciseData.id = lineData.id;
    preciseData.isMain = true;
    preciseData.name = lineData.name;
    
    appendSingleLine(main, preciseData, zoomContext, lineGenerator, zoomPreviewLineGenerator, 'medium-precise-path', false, locationHref);
    appendSingleLine(main, preciseData, zoomContext, lineGenerator, zoomPreviewLineGenerator, 'high-precise-path', false, locationHref);
    appendSingleLine(main, preciseData, zoomContext, lineGenerator, zoomPreviewLineGenerator, 'highest-precise-path', false, locationHref);
  });
}

export const appendSingleLine = (main, lineData, zoomContext, lineGenerator, zoomPreviewLineGenerator, customClasses, preventAppendToZoomContext, locationHref) => {
  customClasses = customClasses ? customClasses : '';

  const regularPath = main
    .append("path")
    .attr('id', 'path-id-' + lineData.id + '_' + customClasses)
    .attr("class", lineData.isMain ? ("line path main " + customClasses) : ("line path " + customClasses)) // Assign a class for styling
    .attr('clip-path', 'url(' + locationHref + '#clip)')
    .attr("fill", "none")
    .style("stroke", lineData.color)
    .style("stroke-dasharray", lineData.isMain ? 0 : ("10, 3"))
    .attr("stroke-linejoin", "round")
    .attr("stroke-linecap", "round")
    .attr("stroke-width", 4);

    regularPath
    .datum(lineData.data)
    .attr("d", lineGenerator)
    .transition()
  
  if(!preventAppendToZoomContext) {
    const zoomPath = zoomContext.select('#zoom-path-id-' + lineData.id);

    if(!regularPath.empty()) {
      const lineDataWithoutNulls = lineData.data.filter(d => d.y !== null);

      zoomContext
      .append("path")
      .attr('id', 'zoom-path-id-' + lineData.id)
      .datum(lineDataWithoutNulls)
      .attr("class", "line zoom-preview-line")
      .attr("d", zoomPreviewLineGenerator)
      .attr('clip-path', 'url(' + locationHref + '#clipPreview)')
      .style("stroke", lineData.color);
    }
  }
}

export const updateGridlines = (main, xScale, xTicks, chartHeight, yScale, yticks, width) => {
  // Add a X gridlines
  main
  .selectAll(".grid.grid-x")
  .attr("transform", "translate(0," + chartHeight + ")")
  .transition()
  .duration(ANIMATION_DURATION)
  .ease(d3.easeLinear)
  .call(
    d3
      .axisBottom(xScale)
      .ticks(xTicks.length)
      .tickValues(xTicks)
      .tickSize(-chartHeight)
      .tickFormat("")
  ); // Create an axis component with d3.axisBottom

  // Add a Y gridlines
  main
    .selectAll(".grid.grid-y")
    .transition()
    .duration(ANIMATION_DURATION)
    .ease(d3.easeLinear)
    .call(
      d3
        .axisLeft(yScale)
        .ticks(yticks.length)
        .tickValues(yticks)
        .tickSize(-width)
        .tickFormat("")
    ); // Create an axis component with d3.axisBottom
}

const segmentLabelOverflowHandler = chartHeight => {
  if(this) {
    var self = d3.select(this);
    var textLength = self.node().getComputedTextLength();
    var text = self.text();

    while (textLength > (chartHeight - 2 * 10) && text.length > 0) {
        text = text.slice(0, -1);
        self.text(text + '...');
        textLength = self.node().getComputedTextLength();
    }
  }
  
}
